/* tslint:disable */
/* eslint-disable */
/**
 * e-SNRWB
 * Opis api e-SNRWB
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GetDictionaryDto,
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
    GetOrganizationDto,
    GetOrganizationDtoFromJSON,
    GetOrganizationDtoFromJSONTyped,
    GetOrganizationDtoToJSON,
    GetProductTypeDto,
    GetProductTypeDtoFromJSON,
    GetProductTypeDtoFromJSONTyped,
    GetProductTypeDtoToJSON,
    GetSampleCollectDto,
    GetSampleCollectDtoFromJSON,
    GetSampleCollectDtoFromJSONTyped,
    GetSampleCollectDtoToJSON,
} from './';

/**
 * 
 * @export
 * @interface GetSampleExamDto
 */
export interface GetSampleExamDto {
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    id: string;
    /**
     * 
     * @type {GetSampleCollectDto}
     * @memberof GetSampleExamDto
     */
    sampleCollect: GetSampleCollectDto;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    protocolNumber: string;
    /**
     * 
     * @type {number}
     * @memberof GetSampleExamDto
     */
    sysNumber: number;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    fileNumber: string;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    technicalSpecification: string;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetSampleExamDto
     */
    organizationType: GetDictionaryDto;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetSampleExamDto
     */
    protocolPrintMode: GetDictionaryDto;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    comments: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSampleExamDto
     */
    approved: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSampleExamDto
     */
    projectPOIiS: boolean;
    /**
     * 
     * @type {GetProductTypeDto}
     * @memberof GetSampleExamDto
     */
    productType: GetProductTypeDto;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    securedQuantity: string;
    /**
     * 
     * @type {Date}
     * @memberof GetSampleExamDto
     */
    expirationDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    expirationText: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSampleExamDto
     */
    expirationNA: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetSampleExamDto
     */
    supplyDate?: Date;
    /**
     * 
     * @type {GetOrganizationDto}
     * @memberof GetSampleExamDto
     */
    supplier: GetOrganizationDto;
    /**
     * 
     * @type {boolean}
     * @memberof GetSampleExamDto
     */
    supplierNA: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSampleExamDto
     */
    supplierUnknown: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetSampleExamDto
     */
    sampleSignatureDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    refusalReason: string;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    repairMethod: string;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    invoiceNumber: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetSampleExamDto
     */
    invoiceNumberNA: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    reasonNotTakingControlSample: string;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    regulations: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSampleExamDto
     */
    regulationIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSampleExamDto
     */
    regulationValues: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    additionalInfo: string;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    findings: string;
    /**
     * 
     * @type {number}
     * @memberof GetSampleExamDto
     */
    orderNo: number;
    /**
     * 
     * @type {Date}
     * @memberof GetSampleExamDto
     */
    completionDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    witnesses: string;
    /**
     * 
     * @type {Date}
     * @memberof GetSampleExamDto
     */
    collectDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetSampleExamDto
     */
    euProjectTypeId: string;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetSampleExamDto
     */
    euProjectType: GetDictionaryDto;
}

export function GetSampleExamDtoFromJSON(json: any): GetSampleExamDto {
    return GetSampleExamDtoFromJSONTyped(json, false);
}

export function GetSampleExamDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSampleExamDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'sampleCollect': GetSampleCollectDtoFromJSON(json['sampleCollect']),
        'protocolNumber': json['protocolNumber'],
        'sysNumber': json['sysNumber'],
        'fileNumber': json['fileNumber'],
        'technicalSpecification': json['technicalSpecification'],
        'organizationType': GetDictionaryDtoFromJSON(json['organizationType']),
        'protocolPrintMode': GetDictionaryDtoFromJSON(json['protocolPrintMode']),
        'comments': json['comments'],
        'approved': json['approved'],
        'projectPOIiS': json['projectPOIiS'],
        'productType': GetProductTypeDtoFromJSON(json['productType']),
        'securedQuantity': json['securedQuantity'],
        'expirationDate': !exists(json, 'expirationDate') ? undefined : (new Date(json['expirationDate'])),
        'expirationText': json['expirationText'],
        'expirationNA': json['expirationNA'],
        'supplyDate': !exists(json, 'supplyDate') ? undefined : (new Date(json['supplyDate'])),
        'supplier': GetOrganizationDtoFromJSON(json['supplier']),
        'supplierNA': json['supplierNA'],
        'supplierUnknown': json['supplierUnknown'],
        'sampleSignatureDate': !exists(json, 'sampleSignatureDate') ? undefined : (new Date(json['sampleSignatureDate'])),
        'refusalReason': json['refusalReason'],
        'repairMethod': json['repairMethod'],
        'invoiceNumber': json['invoiceNumber'],
        'invoiceNumberNA': json['invoiceNumberNA'],
        'reasonNotTakingControlSample': json['reasonNotTakingControlSample'],
        'regulations': json['regulations'],
        'regulationIds': json['regulationIds'],
        'regulationValues': json['regulationValues'],
        'additionalInfo': json['additionalInfo'],
        'findings': json['findings'],
        'orderNo': json['orderNo'],
        'completionDate': !exists(json, 'completionDate') ? undefined : (new Date(json['completionDate'])),
        'witnesses': json['witnesses'],
        'collectDate': !exists(json, 'collectDate') ? undefined : (new Date(json['collectDate'])),
        'euProjectTypeId': json['euProjectTypeId'],
        'euProjectType': GetDictionaryDtoFromJSON(json['euProjectType']),
    };
}

export function GetSampleExamDtoToJSON(value?: GetSampleExamDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'sampleCollect': GetSampleCollectDtoToJSON(value.sampleCollect),
        'protocolNumber': value.protocolNumber,
        'sysNumber': value.sysNumber,
        'fileNumber': value.fileNumber,
        'technicalSpecification': value.technicalSpecification,
        'organizationType': GetDictionaryDtoToJSON(value.organizationType),
        'protocolPrintMode': GetDictionaryDtoToJSON(value.protocolPrintMode),
        'comments': value.comments,
        'approved': value.approved,
        'projectPOIiS': value.projectPOIiS,
        'productType': GetProductTypeDtoToJSON(value.productType),
        'securedQuantity': value.securedQuantity,
        'expirationDate': value.expirationDate === undefined ? undefined : (value.expirationDate.toISOString()),
        'expirationText': value.expirationText,
        'expirationNA': value.expirationNA,
        'supplyDate': value.supplyDate === undefined ? undefined : (value.supplyDate.toISOString()),
        'supplier': GetOrganizationDtoToJSON(value.supplier),
        'supplierNA': value.supplierNA,
        'supplierUnknown': value.supplierUnknown,
        'sampleSignatureDate': value.sampleSignatureDate === undefined ? undefined : (value.sampleSignatureDate.toISOString()),
        'refusalReason': value.refusalReason,
        'repairMethod': value.repairMethod,
        'invoiceNumber': value.invoiceNumber,
        'invoiceNumberNA': value.invoiceNumberNA,
        'reasonNotTakingControlSample': value.reasonNotTakingControlSample,
        'regulations': value.regulations,
        'regulationIds': value.regulationIds,
        'regulationValues': value.regulationValues,
        'additionalInfo': value.additionalInfo,
        'findings': value.findings,
        'orderNo': value.orderNo,
        'completionDate': value.completionDate === undefined ? undefined : (value.completionDate.toISOString()),
        'witnesses': value.witnesses,
        'collectDate': value.collectDate === undefined ? undefined : (value.collectDate.toISOString()),
        'euProjectTypeId': value.euProjectTypeId,
        'euProjectType': GetDictionaryDtoToJSON(value.euProjectType),
    };
}


